import { CameraMode, type PotreeEngine } from '@sharefe/share3d-engine'
import { Vector3 } from 'three'

export const GS3D_EFFECTS_CAMERA_FOV = 65

/** 应用 3DGS 特效示例最终生效的初始相机，供性能基线复用同一取景条件。 */
export function applyGs3dEffectsInitialCamera(engine: PotreeEngine): void {
  engine.camera.fov = GS3D_EFFECTS_CAMERA_FOV
  engine.camera.setState({
    ...engine.camera.getState(),
    mode: CameraMode.Perspective,
    position: new Vector3(0, 0, 2),
    target: new Vector3(0, 1, 2),
    up: new Vector3(0, 0, 1),
  })
}
